var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 316,
    height: 73,
    viewBox: "0 0 316 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_58",
    "data-name": "Group 58",
    transform: "translate(-1214.5 -1420)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    x2: 315,
    transform: "translate(1214.5 1420.5)",
    fill: "none",
    stroke: "#181818",
    strokeWidth: 1,
    strokeDasharray: 10
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_47",
    "data-name": "Line 47",
    y2: 72,
    transform: "translate(1530 1421)",
    fill: "none",
    stroke: "#181818",
    strokeWidth: 1,
    strokeDasharray: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLLine);
export default __webpack_public_path__ + "static/media/L-line.d79c8c6577672299dbcbdff6a301a6cb.svg";
export { ForwardRef as ReactComponent };